import React from "react";
import { Button, Flex, Text, Tooltip, useDisclosure } from "@chakra-ui/react";
import PageHeader from "@/shared/components/PageHeader";
import OrderHistoryFinalCopyRevisionModal from "./OrderHistoryFinalCopyRevisionModal";
import OrderHistoryFinalCopyApproveModal from "./OrderHistoryFinalCopyApproveModal";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import { useSearchParams } from "react-router-dom";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { convertOrderStatusToNew } from "@/shared/utils";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";

function OrderHistoryFinalCopyHeader() {
  const {
    isOpen: isRevisionOpen,
    onOpen: onRevisionOpen,
    onClose: onRevisionClose,
  } = useDisclosure();
  const {
    isOpen: isApproveOpen,
    onOpen: onApproveOpen,
    onClose: onApproveClose,
  } = useDisclosure();

  const { navigate } = useRouterHelper();
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title");
  const status = searchParams.get("status");
  const { tTitle } = useI18nHelper();

  return (
    <>
      <PageHeader
        iconName={"chevron-left"}
        onIconClick={() => navigate(-1)}
        actions={
          <>
            {status &&
              convertOrderStatusToNew(status as OrderSheetStatus) ===
                "BUYER_CONFIRM_REQUIRED" && (
                <>
                  <Button
                    role={"group"}
                    padding={"4px 8px"}
                    background={"#FCFCFB"}
                    borderRadius={"4px"}
                    boxShadow={
                      "0 0 0 0.5px #8F8F8C, 0 2px 4px 0 rgba(0, 0, 0, 0.10)"
                    }
                    height={"fit-content"}
                    onClick={onRevisionOpen}
                    _hover={{
                      boxShadow:
                        "0 0 0 0.5px #1272EF, 0 2px 4px 0 rgba(0, 0, 0, 0.10)",
                    }}
                    _active={{
                      background: "inherit",
                      boxShadow:
                        "0 0 0 0.5px #00417D, 0 2px 4px 0 rgba(0, 0, 0, 0.10)",
                    }}
                  >
                    <Text
                      textStyle={"body-sm-bold"}
                      color={"#444444"}
                      width={"80px"}
                      _groupHover={{
                        color: "#1272EF",
                      }}
                      _groupActive={{
                        color: "#00417D",
                      }}
                    >
                      {tTitle("order_history:confirm.amend_request")}
                    </Text>
                  </Button>
                  <Button
                    padding={"4px 8px"}
                    background={"#1272EF"}
                    borderRadius={"4px"}
                    boxShadow={"0 2px 4px 0 rgba(0, 0, 0, 0.10)"}
                    height={"fit-content"}
                    onClick={onApproveOpen}
                    _hover={{
                      background: "#005AAD",
                    }}
                    _active={{
                      background: "#00417D",
                    }}
                  >
                    <Text
                      textStyle={"body-sm-bold"}
                      color={"#FFFFFF"}
                      width={"80px"}
                    >
                      {tTitle(
                        "order_history:confirm.approve_confirmed_order_sheet"
                      )}
                    </Text>
                  </Button>
                </>
              )}
          </>
        }
      >
        <Flex gap={"8px"} textStyle={"body-lg-bold"} color={"#444444"}>
          <Text>{tTitle("order_history:order_confirm")}</Text>
          <Text textStyle={"body-lg-regular"} color={"#C0C0C0"}>
            |
          </Text>
          <Tooltip hasArrow={true} label={`#${title}`}>
            <Text noOfLines={1}>#{title}</Text>
          </Tooltip>
        </Flex>
      </PageHeader>

      <OrderHistoryFinalCopyRevisionModal
        isOpen={isRevisionOpen}
        onClose={onRevisionClose}
      />

      <OrderHistoryFinalCopyApproveModal
        isOpen={isApproveOpen}
        onClose={onApproveClose}
      />
    </>
  );
}

export default OrderHistoryFinalCopyHeader;
